import {
    fetchBookingData,
    fetchBookingDetail,
    postBooking,
    updateBooking,
    fetchBookingList
} from "../data/apiClient";

import {
    getAppendedBooking,
    getSortedBookingList
} from "./bookingMapper";

export const bookingRepository = {
    getBookingData: async () => {
        const response = await fetchBookingData();
        const bookingData = response.data;
        return bookingData;
    },

    getBookingDetail: async (bookingId) => {
        const response = await fetchBookingDetail(bookingId);
        // Tolerates the backend returning the raw query rows instead of a single object.
        const bookingDetail = Array.isArray(response.data) ? response.data[0] : response.data;
        const bookingDetailAppended = getAppendedBooking(bookingDetail)
        return bookingDetailAppended ?? null;
    },

    postBooking: async (formBody) => {
        try {
            const response = await postBooking(formBody);
            return { success: response.status === 200 };
        } catch (error) {
            return { success: false, message: 'Something went wrong' };
        }
    },

    updateBooking: async (bookingId, fields) => {
        try {
            const response = await updateBooking(bookingId, fields);
            return { success: response.status === 200 };
        } catch (error) {
            return { success: false, message: 'Something went wrong' };
        }
    },

    getBookingList: async () => {
        const response = await fetchBookingList();
        const bookingList = response.data;
        const appendedBookingList = bookingList.map((item) => getAppendedBooking(item));
        const sortedBookingList = getSortedBookingList(appendedBookingList);
        return sortedBookingList;
    }
}